import {sumArrayNumbers} from './sumArrayNumbers';

const sumObjectArrayNumbers = <T>(
	values: T[],
	key: keyof T,
	convertFunc?: (value: string) => number,
) =>
	sumArrayNumbers(
		values.map(value =>
			convertFunc
				? convertFunc(String(value[key] ?? ''))
				: (value[key] as unknown as number) || 0,
		),
	);

export {sumObjectArrayNumbers};
